import ThemeInterface from '@/theme-interface'

// The checkout buttons follow the new brand. Spread into the class passed to ButtonSquare / CancelButton -
// the checkout's style sheets come after the controls' ones, so these rules win.

export const brandPrimaryButton = (theme: ThemeInterface) => ({
  borderRadius: theme.borderRadiusPill,
  background: theme.palette.brand.main,
  color: theme.palette.brand.contrastText,
  '&:hover': {
    background: theme.palette.brand.dark,
    color: theme.palette.brand.contrastText,
  },
  '&:disabled': {
    background: theme.disabledColor,
  },
})

export const brandOutlineButton = (theme: ThemeInterface) => ({
  borderRadius: theme.borderRadiusPill,
  border: `1px solid ${theme.palette.brand.main}`,
  // background: theme.palette.background.paper,
  color: theme.palette.brand.text.heading,
  '&:hover:not(:disabled)': {
    background: theme.palette.brand.light,
    color: theme.palette.brand.text.heading,
  },
})
